var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypeAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 32 32",
    className: "iconify icon:vscode-icons:file-type-ai2",
    "data-inline": "false",
    "data-width": "1em",
    "data-height": "1em",
    "data-icon": "vscode-icons:file-type-ai2",
    style: {
      transform: "rotate(360deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.037 2.072l5.564 5.8v22.056H8.814V30H29.67V7.945l-5.633-5.873",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.965 2H8.742v27.928H29.6V7.873L23.965 2",
    fill: "#231612"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.893 2.072v5.874h5.633l-5.633-5.874",
    fill: "#4c4442"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.965 2v5.873H29.6L23.965 2z",
    fill: "#f36617"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.384 10.264h6.359V3.432H2.384v6.832z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.743 10.264h13.718V3.432H8.743v6.832z",
    fill: "#4c4442"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.407 10.211H2.33V3.379h20.077v6.832",
    fill: "#f36617"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 20.619c-.275-1.07-.948-3.226-1.223-4.344h-.014c-.206 1.054-.769 2.859-1.181 4.344H18.1zm-2.775 1.566l-.838 2.779c-.014.1-.055.128-.137.128h-1.4c-.1 0-.124-.048-.1-.16a858.912 858.912 0 0 1 2.871-9.279a3.686 3.686 0 0 0 .11-.878a.086.086 0 0 1 .082-.1h1.9c.069 0 .082.016.11.08c1.016 3.274 2.129 6.884 3.173 10.19q.041.144-.082.144h-1.542c-.069 0-.1-.032-.124-.1l-.879-2.811h-3.146",
    fill: "#f46c25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 17.547c0-.1.027-.128.094-.128h1.431c.081 0 .108.016.108.128v7.506c0 .08-.027.128-.108.128h-1.4c-.081 0-.121-.032-.121-.144v-7.49zm-.09-2.173a.918.918 0 0 1 .918-.99a.884.884 0 0 1 .891.99a.908.908 0 1 1-1.809 0",
    fill: "#f46c25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.238 5.279h-.013L10.9 7.352h.652zM9.5 9.3l1.06-4.86h1.355l1.033 4.86H11.81l-.15-1.133h-.882L10.634 9.3H9.5",
    fill: "#231612"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.438 9.3V4.44h1.086V9.3h-1.086",
    fill: "#231612"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeAi);
export default __webpack_public_path__ + "static/media/file_type_ai.6b637921.svg";
export { ForwardRef as ReactComponent };